<ng-container
  *ngIf="cs.vm$ | async as vm"
  [dgxGaContainer]="{ eventCategory: 'payment details form' }"
>
  <p *ngIf="vm.showRequiredFieldLegend" class="mb-6">
    {{ 'DIRECT_DEBIT_FORM_REQUIRED_FIELD' | translate }}
  </p>
  <form
    *ngIf="vm.form as form"
    (submitted)="onFormSubmit($event)"
    [dgxFormDisabled]="vm.purchasing || vm.validatingAccountDetails"
    [dgxTestHook]="testHooks.Form"
    [formGroup]="form"
    class="direct-debit-details-form mb-6"
    dgxFormSubmit
    dgxGaFormSubmit
  >
    <dgx-form-fieldset class="direct-debit-form__fieldset">
      <ng-container [ngSwitch]="vm.directDebitMethod">
        <ng-container *ngSwitchCase="directDebitMethod.AccountNumberSortCode">
          <ng-container *ngIf="vm.userDirectDebitDetails">
            <h3 class="typog-h2 mb-6">
              {{ 'DIRECT_DEBIT_FORM_SIGNED_IN_DETAILS_TITLE' | translate }}
              <i class="icon icon--xl icon-lock"></i>
            </h3>
            <p class="mb-4">
              {{
                (vm.editingDirectDebitDetails
                  ? 'DIRECT_DEBIT_FORM_SIGNED_IN_DETAILS_SUBTITLE_WHEN_EDITING'
                  : 'DIRECT_DEBIT_FORM_SIGNED_IN_DETAILS_SUBTITLE'
                ) | translate
              }}
            </p>
          </ng-container>

          <ng-container
            *ngIf="
              vm.showExistingUserDirectDebitDetails;
              else accountNumberSortCodeForm
            "
          >
            <checkout-user-direct-debit-details />
          </ng-container>

          <ng-template #accountNumberSortCodeForm>
            <dgx-form-row>
              <dgx-form-field
                [dgxFormField]="vm.cmsData.accountNameField"
                [dgxTestHook]="testHooks.AccountName"
                [trackFormField]="'status'"
                dgxGaFormField
                formControlName="accountName"
              >
                <dgx-form-text-input [dgxQmSanitise]="'block'" />
              </dgx-form-field>
            </dgx-form-row>
            <dgx-form-row>
              <dgx-form-field
                [dgxFormField]="vm.cmsData.accountNumberField"
                [dgxTestHook]="testHooks.AccountNumber"
                [trackFormField]="'status'"
                dgxGaFormField
                formControlName="accountNumber"
              >
                <dgx-form-number-input
                  [dgxQmSanitise]="'block'"
                  [maxIntegerDigits]="8"
                  [pretty]="false"
                />
              </dgx-form-field>
            </dgx-form-row>

            <dgx-form-row>
              <dgx-form-field
                [dgxFormField]="vm.cmsData.sortCodeField"
                [dgxTestHook]="testHooks.SortCode"
                [trackFormField]="'status'"
                dgxGaFormField
                formControlName="sortCode"
              >
                <dgx-form-sortcode-input [dgxQmSanitise]="'block'" />
              </dgx-form-field>
            </dgx-form-row>
          </ng-template>

          <dgx-form-row class="mt-4">
            <dgx-form-field
              [dgxFormField]="vm.cmsData.paymentDateField"
              [dgxTestHook]="testHooks.PaymentDate"
              [trackFormField]="'status'"
              dgxGaFormField
              formControlName="paymentDate"
            >
              <dgx-form-select
                [dgxQmSanitise]="'block'"
                [options]="vm.directDebitPaymentDateOptions"
              />
            </dgx-form-field>
          </dgx-form-row>

          <dgx-components-button
            *ngIf="vm.userDirectDebitDetails"
            (clicked)="
              cs.updateEditingDirectDebitDetails(!vm.editingDirectDebitDetails)
            "
            [variant]="vm.editingDirectDebitDetails ? 'primary' : 'secondary'"
            class="mb-md"
          >
            {{
              (vm.editingDirectDebitDetails
                ? 'DIRECT_DEBIT_FORM_EDIT_DIRECT_DEBIT_DETAILS_CANCEL'
                : 'DIRECT_DEBIT_FORM_EDIT_DIRECT_DEBIT_DETAILS'
              ) | translate
            }}
          </dgx-components-button>
        </ng-container>

        <ng-container *ngSwitchCase="directDebitMethod.IBAN">
          <dgx-form-row>
            <dgx-form-field
              [dgxFormField]="vm.cmsData.accountNameField"
              [dgxTestHook]="testHooks.AccountName"
              [trackFormField]="'status'"
              dgxGaFormField
              formControlName="accountName"
            >
              <dgx-form-text-input [dgxQmSanitise]="'block'" />
            </dgx-form-field>
          </dgx-form-row>
          <dgx-form-row>
            <dgx-form-field
              [dgxFormField]="vm.cmsData.ibanField"
              [dgxTestHook]="testHooks.Iban"
              [trackFormField]="'status'"
              dgxGaFormField
              formControlName="iban"
            >
              <dgx-form-text-input [dgxQmSanitise]="'block'" />
            </dgx-form-field>
          </dgx-form-row>
          <dgx-form-row>
            <dgx-form-field
              [dgxFormField]="vm.cmsData.paymentDateField"
              [dgxTestHook]="testHooks.PaymentDate"
              [trackFormField]="'status'"
              dgxGaFormField
              formControlName="paymentDate"
            >
              <dgx-form-select
                [dgxQmSanitise]="'block'"
                [options]="vm.directDebitPaymentDateOptions"
              />
            </dgx-form-field>
          </dgx-form-row>
        </ng-container>
      </ng-container>

      <dgx-form-row>
        <dgx-form-field
          [dgxFormField]="vm.cmsData.accountHolderConfirmationField"
          [dgxTestHook]="testHooks.AccountHolder"
          formControlName="accountHolderConfirmation"
        >
          <dgx-form-checkbox [dgxQmSanitise]="'block'" [size]="'medium'" />
        </dgx-form-field>
      </dgx-form-row>

      <ng-container
        *dgxBasketHasSelectedProductType="
          productType.BoilerCare;
          else applianceCareSection
        "
      >
        <checkout-protection-start-summary-panel
          [body]="vm.cmsData.protectionStartSummaryPanelBodyBoilers"
          [title]="vm.cmsData.protectionStartSummaryPanelTitleBoilers"
        />
      </ng-container>

      <ng-template #applianceCareSection>
        <div
          *ngIf="showDirectDebitGuarantee"
          class="checkout-direct-debit-panel"
        >
          <dgx-components-accordion-panel
            [spacing]="0"
            [theme]="'neutral-primary-light'"
            [title]="vm.cmsData.directDebitGuaranteeTitle"
          >
            <checkout-direct-debit-guarantee-panel
              [legalTerms]="
                vm.cmsData.directDebitGuaranteeLegalTerms
                  | dgxInterpolate
                    : {
                        legalProvider: vm.legalProvider,
                        numberWorkingDays: vm.numberWorkingDays
                      }
              "
              class="checkout-direct-debit-guarantee-panel"
            />
          </dgx-components-accordion-panel>
        </div>

        <div class="mb-6">
          <dgx-components-content
            [body]="
              vm.cmsData.directDebitInstructionConfirmationBody
                | dgxInterpolate
                  : {
                      legalProvider: vm.legalProvider
                    }
            "
            [textAlign]="'left'"
          />
        </div>
        <div class="mb-6">
          <checkout-protection-start-summary-panel
            [body]="vm.cmsData.protectionStartSummaryPanelBodyWhiteGoods"
            [title]="vm.cmsData.protectionStartSummaryPanelTitleWhiteGoods"
          />
        </div>
      </ng-template>
    </dgx-form-fieldset>

    <checkout-terms-and-conditions-fieldset
      *dgxFeatureEnabled="termsAndConditionsFeature"
      [quotes]="vm.selectedQuotes"
    />

    <checkout-paperless-preference-fieldset
      *ngIf="vm.cmsData.paperlessPreferenceFieldset as cmsData"
      [dgxFormFieldset]="cmsData"
      [paperlessPreferenceField]="cmsData.paperlessPreferenceField"
    />

    <dgx-form-row>
      <dgx-form-submit-button
        [fill]="true"
        [loading]="vm.purchasing || vm.validatingAccountDetails"
        class="direct-debit-form__action"
        >{{ 'DIRECT_DEBIT_FORM_SUBMIT_BUTTON' | translate }}
      </dgx-form-submit-button>
    </dgx-form-row>
  </form>
</ng-container>
